import { createAsyncThunk } from '@reduxjs/toolkit';
import { get, put } from '../models/base';

export const fetchFolders = createAsyncThunk(
  'folders/fetchFolders',
  async (albumId, { rejectWithValue }) => {
    try {
      const response = await get(`/api/albums/${albumId}/folders`);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const updatefolderSequence = createAsyncThunk(
  'folders/updatefolderSequence',
  async (ids, { rejectWithValue, getState }) => {
    const { album } = getState().album;

    try {
      const response = await put(`/albums/${album.id}/bulk_sequence_updation`, {
        ids: ids,
      });
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
